import React, { useEffect, useRef, useState } from "react";

import {
  Avatar,
  Badge,
  Dropdown,
  Button,
  Typography,
  message,
} from "antd";

import {
  UserOutlined,
  ProfileOutlined,
  LogoutOutlined,
  CameraOutlined,
} from "@ant-design/icons";

import api, { BASE_URL } from "../api/api";
import AddAcademyYear from "./AcademyYearSelection/AddAcademyYear";
import AdminPublishGradesPopup from "../SchoolDashApp/AdminPublishGradesPopup";
import { Link } from 'react-router-dom';



const { Text } = Typography;

const PROFILE_UPDATED_EVENT = "profileUpdated";


const ProfileImage = ({ theme, header = false }) => {
  const [user, setUser] = useState(null);
  const fileInputRef = useRef(null);
  const [openAcademyYear, setOpenAcademyYear] = useState(false);
  const [openPublishGrades,setOpenPublishGrades] = useState(false);




  // Refresh academic years after adding
  const fetchAcademicYears = async () => {
    try {

      await api.get("/academic-years/");

      window.dispatchEvent(
        new Event("academicYearUpdated")
      );

    } catch (error) {

      console.log(
        "Academic years fetch error:",
        error
      );

    }
  };



  // Fetch User Profile
  const fetchProfile = async () => {
    try {

      const res = await api.get("/user-profile/");

      setUser(res.data);

    } catch (error) {

      console.log(
        "Profile fetch error:",
        error
      );

    }
  };



  useEffect(() => {

    fetchProfile();


    const updateProfile = () => {
      fetchProfile();
    };


    window.addEventListener(
      PROFILE_UPDATED_EVENT,
      updateProfile
    );


    return () => {

      window.removeEventListener(
        PROFILE_UPDATED_EVENT,
        updateProfile
      );

    };

  }, []);



  // Profile Image URL
  const getProfileImage = () => {

    if (!user?.profile_image) {
      return null;
    }


    if (user.profile_image.startsWith("http")) {
      return user.profile_image;
    }


    return `${BASE_URL}${user.profile_image}?${Date.now()}`;

  };



  // Upload Profile Image
  const handleImageChange = async (e) => {

    const file = e.target.files[0];


    if (!file) {
      return;
    }


    const formData = new FormData();


    formData.append(
      "profile_image",
      file
    );


    try {

      const res = await api.put(
        "/user-profile/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );


      setUser(res.data);


      window.dispatchEvent(
        new Event(PROFILE_UPDATED_EVENT)
      );


      message.success(
        "Profile image updated successfully"
      );


    } catch (error) {

      console.log(error);


      message.error(
        "Profile image update failed"
      );

    }

  };
    // Logout Function
  const handleLogout = async () => {

    try {

      await api.post("/api/logout/");

      localStorage.removeItem("access");
      localStorage.removeItem("refresh");

      window.location.href = "/login";


    } catch (error) {

      console.log(
        "Logout error:",
        error
      );

    }

  };



  const menuItems = [

    {
      key: "profile",
      icon: <ProfileOutlined />,
      label: "My Profile",
    },

    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Logout",
      danger: true,
    },

  ];



  return (
    <>

      <Dropdown

        placement="bottomRight"

        menu={{
          items: menuItems,

          onClick: ({ key }) => {

            if (key === "logout") {
              handleLogout();
            }

          },

        }}

      >


        <div

          style={{

            cursor: "pointer",

            display: "flex",

            flexDirection: header
              ? "row"
              : "column",

            alignItems: "center",

            justifyContent: "center",

            gap: header
              ? 12
              : 10,

            padding: header
              ? 0
              : "18px 12px",

            width: header
              ? "auto"
              : "100%",

            borderRadius: 16,

            background: header
              ? "transparent"
              : theme.darkMode
                ? "#1e293b"
                : "#ffffff",

            border: header
              ? "none"
              : `1px solid ${theme.border}`,

            margin: header
              ? 0
              : "18px 0",

          }}

        >


          {/* PROFILE IMAGE */}

          <div
            style={{
              position: "relative",
            }}
          >


            <Badge

              dot

              status={
                user?.is_online
                  ? "success"
                  : "default"
              }

              offset={
                header
                  ? [-3, 38]
                  : [-5, 55]
              }

            >


              <Avatar

                size={
                  header
                    ? 46
                    : 68
                }

                src={getProfileImage()}

                icon={
                  <UserOutlined />
                }

                style={{

                  border:
                    `3px solid ${theme.primary}`,

                  flexShrink: 0,

                }}

              />


            </Badge>


            {/* CAMERA BUTTON ONLY SIDEBAR */}

            {
              !header &&

              <>

                <input

                  type="file"

                  accept="image/*"

                  ref={fileInputRef}

                  onChange={handleImageChange}

                  style={{
                    display: "none",
                  }}

                />


                <div

                  onClick={(e) => {

                    e.stopPropagation();

                    fileInputRef.current.click();

                  }}

                  style={{

                    position: "absolute",

                    bottom: -3,

                    right: 0,

                    width: 26,

                    height: 26,

                    borderRadius: "50%",

                    background: theme.primary,

                    color: "#fff",

                    display: "flex",

                    alignItems: "center",

                    justifyContent: "center",

                    border: "2px solid white",

                  }}

                >

                  <CameraOutlined
                    style={{
                      fontSize: 13,
                    }}
                  />

                </div>

              </>

            }


          </div>
          {/* USER DETAILS ONLY SIDEBAR */}

          {
            !header &&

            <div

              style={{

                display: "flex",

                flexDirection: "column",

                alignItems: "center",

                width: "100%",

              }}

            >


              <Text

                strong

                style={{
                  color: theme.text,
                }}

              >

                {
                  user?.username ||
                  "Loading..."
                }

              </Text>


              <Text

                style={{

                  fontSize: 12,

                  color: theme.secondary,

                }}

              >

                {
                  user?.email ||
                  ""
                }

              </Text>



              <Text

                style={{

                  fontSize: 12,

                  color: theme.primary,

                  fontWeight: 600,

                }}

              >

                {
                  user?.user_type ||
                  ""
                }

              </Text>

               <br/>

             


            </div>

          }

              





          {/* ADD ACADEMIC YEAR BUTTON ONLY SIDEBAR */}

{
  !header &&
  [
    "admin",
    "registry",
    "fiscal affairs",
    "principal",
    "vpi",
    "vpa",
    "dean",
    "it personel",
  ].includes(user?.user_type) && (

    <div
      style={{
        width: "100%",
        marginTop: 15,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
  style={{
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    alignItems: "center",
  }}
>
   <Link to="/chatApp" style={{ textDecoration: 'none' }}>
    <Button
    variant="contained"
    >
    Chats
  </Button> 
   </Link>
</div>
  </div>
)
}
</div>
  </Dropdown>
     {/* ACADEMIC YEAR MODAL */}

      <AddAcademyYear

        open={openAcademyYear}

        handleClose={() => {

          setOpenAcademyYear(false);

        }}

        refreshYears={fetchAcademicYears}

      />

{/* Popups */}
<div>
  <AdminPublishGradesPopup

open={openPublishGrades}

onClose={()=>setOpenPublishGrades(false)}

/>


</div>

    </>

  );

};


export default ProfileImage;